<template>
  <VDialogV3
    id="unit-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localUnit"
    :context-menu="localUnit?.isExisting ? UnitsService.contextMenu : null"
    @submit="onSubmit"
  >
    <section>
      <VInput
        v-model="localUnit.nameFull"
        label="Полное название единицы измерения"
        layout="vertical"
        required
        :max-length="150"
      />

      <VInput
        v-model="localUnit.name"
        label="Сокращенное название единицы измерения"
        layout="vertical"
        required
        :max-length="30"
      />

      <VInput
        v-model="localUnit.code"
        label="Код по ОКЕИ"
        layout="vertical"
        :validate-method="validateCode"
      />

      <VInputNumberRusV2
        v-model="localUnit.qtyMultiplier"
        :type="QtyMultiplier"
        label="Множитель количества"
        layout="vertical"
        required
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import Unit               from '@/domains/Units/Unit';
import UnitsService       from '@/domains/Units/UnitsService';
import QtyMultiplier         from "@/core/types/QtyMultiplier";

export default defineComponent({
  name: 'UnitCard',

  props: {
    id: {
      type:    Number,
      default: null,
    },
  },

  data() {
    return {
      UnitsService,

      localUnit: null as Unit | null,
    };
  },

  setup() {
    return {
      QtyMultiplier,
    }
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localUnit = await UnitsService.get(this.id);
      }
      else {
        this.localUnit = new Unit();
      }
    },

    async onSubmit(): Promise<void> {

      const success = (this.localUnit?.isExisting) ? await UnitsService.update(this.localUnit) : await UnitsService.add(this.localUnit!);

      if (success) {
        this.$core.dialogs.UnitCard.resolve();
      }
    },

    // ==================== Валидация ====================

    validateCode(value: string): string | null {
      if (!value) return null;

      const parsedValue = Number(value);
      if (!Number.isInteger(parsedValue)) return 'Число должно быть целым';
      if (parsedValue < 1 || parsedValue > 32767) return 'Число должно быть между 0 и 32767';
      return null;
    },
  },
});
</script>
